import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {logout} from "../../../store/actions/auth";
import PropTypes from "prop-types";
import {getNotifications} from "../../../store/actions/notification";
import classnames from "classnames";
import defaultImage from "../../../assets/img/default-img.png";

class Header extends Component {
  state = {
    menuIsOpen: false
  };

  componentWillMount() {
    this.props.getNotifications(this.props.user.role);
  }

  onLogout(ev) {
    ev.preventDefault();
    this.props.logout();
  }

  getCompanyImage() {
    return this.props.user.company ? this.props.user.company.image : defaultImage;
  }

  getNotificationsCount() {
    return this.props.notifications.concat(this.props.requestToChange).length;
  }

  toggleMenu() {
    this.setState({
      menuIsOpen: !this.state.menuIsOpen
    });
  }

  render() {
    return (
        <header>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <nav className="navbar navbar-light navbar-expand-lg">
                  <Link to="/dashboard" className="navbar-brand">
                    <img alt="Logo" src={this.getCompanyImage()}/>
                  </Link>
                  <button onClick={this.toggleMenu.bind(this)} className="navbar-toggler" type="button"
                          data-toggle="collapse"
                          data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                          aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"/>
                  </button>
                  <div className={classnames('collapse navbar-collapse', {'show': this.state.menuIsOpen})}
                       id="navbarSupportedContent">
                    <ul className="navbar-nav ml-auto">
                      <li className="nav-item">
                        <a className="nav-link hidden">Dashboard<i className="icon-booking"/></a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link hidden">Warehouses<i className="icon-warehouse"/></a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link hidden">Users<i className="icon-users"/></a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link hidden">Account information<i className="icon-user"/></a>
                      </li>
                      <li className="nav-item">
                        <Link to="/notifications"
                              className={classnames('nav-link', {'notification': !!this.props.notifications.length})}
                              notif-count={this.getNotificationsCount()}>Notifications<i
                            className="icon-bell"/></Link>
                      </li>
                      <li className="nav-item">
                        <a onClick={this.onLogout.bind(this)} className="nav-link">Log out <i
                            className="icon-sign-out"/></a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </header>
    );
  }
}

Header.propTypes = {
  logout: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  getNotifications: PropTypes.func.isRequired,
  requestToChange: PropTypes.array
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  getNotifications: role => dispatch(getNotifications(role))
});

const mapStateToProps = state => ({
  user: state.auth.user,
  notifications: state.notification.notifications,
  requestToChange: state.notification.requestToChange
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Layout/Header/Header.jsx